module.exports = __webpack_public_path__ + "img/touyingyi.9c60373e.png";